/**
===================================================
Module: frontend.src.components.visualizer.SceneAndControls.tsx
Description: Combined 3D scene and controls container component for VSLAM visualizer
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import React from "react";
import ThreeJSScene from "./ThreeJSScene";
import VisualizationControls from "./VisualizationControls";
import ExportButton from "./ExportButton";
import { useVisualizer } from "../../contexts/VisualizerContext";

const SceneAndControls: React.FC = () => {
  const { resetCamera } = useVisualizer();

  return (
    <div className="scene-and-controls">
      <div className="scene-container">
        <ExportButton />
        <ThreeJSScene />
      </div>
      <VisualizationControls onResetCamera={resetCamera} />
    </div>
  );
};

export default SceneAndControls;
